"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _defineProperty = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _imageSizeMap;

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .transparent-preview {\n    opacity: 0 !important;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = exports.ImageFallbackSize = exports.useImageLoad = exports.ImageLoadResult = exports.useImageLoadCallback = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

function useImageLoadCallback(src, onLoad, onError) {
  react_1.default.useEffect(function () {
    if (onLoad || onError) {
      var image = new window.Image();
      image.src = src;
      if (onLoad) image.onload = onLoad;
      if (onError) image.onerror = onError;
    }
  }, [src]);
}

exports.useImageLoadCallback = useImageLoadCallback;
var ImageLoadResult;

(function (ImageLoadResult) {
  ImageLoadResult[ImageLoadResult["Loading"] = 0] = "Loading";
  ImageLoadResult[ImageLoadResult["Loaded"] = 1] = "Loaded";
  ImageLoadResult[ImageLoadResult["Error"] = 2] = "Error";
})(ImageLoadResult = exports.ImageLoadResult || (exports.ImageLoadResult = {}));

function useImageLoad(src) {
  var _react_1$default$useS = react_1.default.useState(ImageLoadResult.Loading),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      loading = _react_1$default$useS2[0],
      setLoading = _react_1$default$useS2[1];

  useImageLoadCallback(src, function () {
    return setLoading(ImageLoadResult.Loaded);
  }, function () {
    return setLoading(ImageLoadResult.Error);
  });
  react_1.default.useEffect(function () {
    setLoading(ImageLoadResult.Loading);
  }, [src]);
  return loading;
}

exports.useImageLoad = useImageLoad;
var ImageFallbackSize;

(function (ImageFallbackSize) {
  ImageFallbackSize[ImageFallbackSize["Small"] = 0] = "Small";
  ImageFallbackSize[ImageFallbackSize["Medium"] = 1] = "Medium";
  ImageFallbackSize[ImageFallbackSize["Large"] = 2] = "Large";
})(ImageFallbackSize = exports.ImageFallbackSize || (exports.ImageFallbackSize = {}));

var imageSizeMap = (_imageSizeMap = {}, _defineProperty(_imageSizeMap, ImageFallbackSize.Small, '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256"><defs/><defs><path id="a" d="M128 44c-46.388 0-84 37.612-84 84 0 46.387 37.612 84 84 84 46.387 0 84-37.613 84-84 0-46.388-37.613-84-84-84zm-6 43.5c0-.825.675-1.5 1.5-1.5h9c.825 0 1.5.675 1.5 1.5v51c0 .825-.675 1.5-1.5 1.5h-9c-.825 0-1.5-.675-1.5-1.5v-51zm6 82.5a9.002 9.002 0 010-18 9.002 9.002 0 010 18z"/></defs><g fill="none" fill-rule="evenodd"><path fill="[BACKGROUND]" d="M0 0h256v256H0z"/><use fill="[ICON]" fill-rule="nonzero" xlink:href="#a"/></g></svg>'), _defineProperty(_imageSizeMap, ImageFallbackSize.Medium, '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256"><defs/><defs><path id="a" d="M128 64c-35.343 0-64 28.657-64 64s28.657 64 64 64 64-28.657 64-64-28.657-64-64-64zm-4.571 33.143c0-.629.514-1.143 1.142-1.143h6.858c.628 0 1.142.514 1.142 1.143V136c0 .629-.514 1.143-1.142 1.143h-6.858A1.146 1.146 0 01123.43 136V97.143zM128 160a6.859 6.859 0 010-13.714A6.859 6.859 0 01128 160z"/></defs><g fill="none" fill-rule="evenodd"><path fill="[BACKGROUND]" d="M0 0h256v256H0z"/><use fill="[ICON]" fill-rule="nonzero" xlink:href="#a"/></g></svg>'), _defineProperty(_imageSizeMap, ImageFallbackSize.Large, '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 256 256"><defs/><defs><path id="a" d="M128 96c-17.671 0-32 14.329-32 32s14.329 32 32 32 32-14.329 32-32-14.329-32-32-32zm-2.286 16.571c0-.314.257-.571.572-.571h3.428c.315 0 .572.257.572.571V132a.573.573 0 01-.572.571h-3.428a.573.573 0 01-.572-.571v-19.429zM128 144a3.43 3.43 0 010-6.857 3.43 3.43 0 010 6.857z"/></defs><g fill="none" fill-rule="evenodd"><path fill="[BACKGROUND]" d="M0 0h256v256H0z"/><use fill="[ICON]" fill-rule="nonzero" xlink:href="#a"/></g></svg>'), _imageSizeMap);

function Image(_a) {
  var _a$fallbackSize = _a.fallbackSize,
      fallbackSize = _a$fallbackSize === void 0 ? ImageFallbackSize.Small : _a$fallbackSize,
      transparentPreview = _a.transparentPreview,
      props = __rest(_a, ["fallbackSize", "transparentPreview"]);

  var content = react_1.default.createElement(antd_1.Image, Object.assign({
    placeholder: !props.src,
    fallback: imageSizeMap[fallbackSize]
  }, props, {
    preview: transparentPreview ? Object.assign(Object.assign({}, typeof props.preview === 'object' ? props.preview : {}), {
      maskClassName: 'transparent-preview'
    }) : props.preview || false
  }));

  if (transparentPreview) {
    return react_1.default.createElement(TransparentPreviewContainer, {
      children: content
    });
  } else return content;
}

exports.Image = Image;
var TransparentPreviewContainer = styled_components_1.default.div(_templateObject());